export const DATA_UPDATE_GROUP_IDS = [
    'address',
    'contact',
    'maritalStatus',
    'children',
    'bankAccount',
    'education',
] as const;

export type DataUpdateGroupId = (typeof DATA_UPDATE_GROUP_IDS)[number];

export interface DataUpdateGroupDefinition {
    id: DataUpdateGroupId;
    label: string;
    fields: readonly string[];
    requiresAttachment: boolean;
}

export const DATA_UPDATE_FIELD_LABELS: Record<string, string> = {
    addresses: 'Endereço',
    isMailingSameAsMain: 'Correspondência igual ao endereço principal',
    personalEmail: 'E-mail pessoal',
    phone: 'Telefone',
    emergencyContact: 'Contato de emergência',
    maritalStatus: 'Estado civil',
    spouseName: 'Nome do cônjuge',
    children: 'Filhos',
    salaryAccount: 'Conta salário',
    personalAccount: 'Conta pessoal',
    educations: 'Formação',
};

export const DATA_UPDATE_GROUPS: readonly DataUpdateGroupDefinition[] = [
    { id: 'address', label: 'Endereço', fields: ['addresses', 'isMailingSameAsMain'], requiresAttachment: false },
    { id: 'contact', label: 'Contato', fields: ['personalEmail', 'phone', 'emergencyContact'], requiresAttachment: false },
    { id: 'maritalStatus', label: 'Estado civil', fields: ['maritalStatus', 'spouseName'], requiresAttachment: false },
    { id: 'children', label: 'Filhos', fields: ['children'], requiresAttachment: false },
    { id: 'bankAccount', label: 'Conta bancária', fields: ['salaryAccount', 'personalAccount'], requiresAttachment: false },
    { id: 'education', label: 'Formação', fields: ['educations'], requiresAttachment: false },
];

export function groupsRequiringAttachment(groupIds: readonly string[]): string[] {
    return groupIds.filter(id => getDataUpdateGroup(id)?.requiresAttachment === true);
}

export function getDataUpdateGroup(id: string): DataUpdateGroupDefinition | undefined {
    return DATA_UPDATE_GROUPS.find(group => group.id === id);
}

export function isDataUpdateGroupId(value: string): value is DataUpdateGroupId {
    return DATA_UPDATE_GROUP_IDS.includes(value as DataUpdateGroupId);
}

export function getFieldsForGroups(groupIds: readonly string[]): string[] {
    const fields = new Set<string>();
    for (const id of groupIds) {
        const group = getDataUpdateGroup(id);
        if (!group) continue;
        group.fields.forEach(field => fields.add(field));
    }
    return Array.from(fields);
}
